import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Repo from "./Utility/Repo";
import useLocalStorage from "./Utility/useLocalStorage";

function RegistrationForm() {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [passwordError, setpasswordError] = useState("");
  const [emailError, setemailError] = useState("");
  const [localStorage, setLocalStorage] = useLocalStorage("LoginUser");
  const [errorRegister, setErrorRegister] = useState(false);

  const handleValidation = (event) => {
    let formIsValid = true;

    if (
      !email.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/)
    ) {
      formIsValid = false;
      setemailError("Email non Valida!");
      formIsValid = false;
    } else {
      setemailError("");
      formIsValid = true;
    }

    if (!(password.length >= 8 && password.length <= 22)) {
      formIsValid = false;
      setpasswordError(
        "La lunghezza deve essere di almeno 8 caratteri e al massimo di 22."
      );
      formIsValid = false;
    } else {
      setpasswordError("");
      formIsValid = true;
    }

    return formIsValid;
  };

  const registerSubmit = (e) => {
    e.preventDefault();
    var data = {
      email: email,
      password: password,
    };

    if (handleValidation()) {
      data = JSON.stringify(data);
      Repo.registerUser(data)
        .then((response) => {
          if (response.data.message.toString() == "success") {
            setLocalStorage(response.data.data);
            window.location.href = "/";
          } else {
            setErrorRegister(true);
          }
        })
        .catch((err) => {
          setErrorRegister(true);
          console.log(err);
        });
    }
  };

  return (
    <>
      <div className="row">
        <h2 className="mt-5 text-center">Registrati</h2>
      </div>
      <div className="container mt-3 mb-5">
        <div className="row d-flex justify-content-center">
          <div className="col-md-4">
            <form
              id="loginform"
              onSubmit={registerSubmit}
              style={{
                padding: "25px",
                border: "1px solid black",
                borderRadius: "5px",
              }}
            >
              <div className="form-group mt-2">
                <label>Email:</label>
                <input
                  type="email"
                  className="form-control"
                  id="EmailInput"
                  name="EmailInput"
                  aria-describedby="emailHelp"
                  placeholder="Email"
                  onChange={(event) => setEmail(event.target.value)}
                />
                <p style={{ fontSize: "13px" }}>
                  Assicurati di inserire un'email valida.
                </p>
                <small id="emailHelp" className="text-danger form-text">
                  {emailError}
                </small>
              </div>
              <div className="form-group mt-2">
                <label>Password:</label>
                <input
                  type="password"
                  className="form-control"
                  id="exampleInputPassword1"
                  placeholder="Password"
                  onChange={(event) => setPassword(event.target.value)}
                />
                <small id="passworderror" className="text-danger form-text">
                  {passwordError}
                </small>
              </div>
              <p style={{ fontSize: "13px" }}>
                Per una maggiore sicurezza, la password deve essere di almeno 8
                caratteri.
              </p>
              {errorRegister && (
                <>
                  <h5 className="text-danger">Registrazione Fallita!</h5>
                </>
              )}
              <button
                type="submit"
                className="btn btn-primary mt-3"
                style={{ marginLeft: "37%", width: "auto" }}
              >
                Registrati
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
export default RegistrationForm;
